import { render, staticRenderFns } from "./ContactTransactions.vue?vue&type=template&id=da8482a8"
import script from "./ContactTransactions.vue?vue&type=script&lang=js"
export * from "./ContactTransactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports